import React from "react";
import styles from "./MultiAccountTray.scss";
import { getLocalizedStrings } from "../../centralizedLocalizedString";
import { getLocalizedStringstwo } from "../../centralizedLocalizedStringtwo";
import OutageAlertContainer from "../OutageAlerts/outageAlertContainer";
import EmergencyAlertContainer from "../EmergencyAlerts/emergencyAlertContainer";
import PaperlessBillingContainer from "../PB/PaperlessBillingContainer";
import BudgetAssistantContainer from "../BudgetAssistance/budgetAssistanceContainer";
import CriticalPeakPricing from "./cpp/CriticalPeakPricing";
import SubHeader from "./SubHeader";

const MultiAccountTray = (props) => {
  let strings = getLocalizedStringstwo("MyAccountUser");
  let paprString = getLocalizedStrings("PaperlessBilling");
  let cppString = getLocalizedStrings("CppAlerts");
  let accountDetails = props.accountDetails;
  let preferenceDetails = props.preferenceDetails;
  let contractResults = props.contractResults;
  let isActiveAccount = props.accountDetails.contractAccountStatus === app.appUtil.getAppConstants().MY_ACCOUNT_SERVICES.ACTIVE_ENROLLMENT_STATUS;
  let isPendingAccount = props.accountDetails.contractAccountStatus === app.appUtil.getAppConstants().MY_ACCOUNT_SERVICES.STATUS_PENDING;
  return (
   
    <div>   
      <div className={styles.cardCointainer}>
        {!props.isWebUser ? 
        <div>
          <PaperlessBillingContainer
            AlertName1={paprString.AlertName1}
            AlertName2={paprString.AlertName2}
            AlertExp={paprString.AlertExp}
            accountData={accountDetails}
            preferenceData={preferenceDetails[0].papr}
            cpcData={props.cpcData}
            customerData={props.customerData}
            contractAccountNumber={props.contractAccountNumber}
            contractAccountCount={props.contractAccountCount}
            getMyAccountDetails={props.getMyAccountDetails}
            getWebUserDetails={props.getWebUserDetails}
            paprRecord={props.paprRecord} prefData={props.prefData} depaprRecord={props.depaprRecord}
            refreshPage={props.onContractAccountClick}
            cpcPageNumber={props.cpcPageNumber}
            staticContent={props.staticContent.pb}
            dropDownData={props.dropDownData}
            updateDropDownData={props.updateDropDownData}
            onPbToggleOnOffClick={props.onPbToggleOnOffClick}
            ebillpaprRecord={props.ebillpaprRecord} ebillpaprSold={props.ebillpaprSold} ebillpaprAuth={props.ebillpaprAuth}
            ebillpaprCount={props.ebillpaprCount}
          />
        </div> : null}
        {contractResults.map((data) => {
          return (
            <div>
             {(data.contractStatus!==app.appUtil.getAppConstants().MY_ACCOUNT_SERVICES.STATUS_INACTIVE)?
              <SubHeader
                isContractResultExpanded={props.isContractResultExpanded}
                onContractResultClick={props.onContractResultClick}
                contractResult={data}
                contractNumber={props.contractNumber}
                accountData={accountDetails}
              /> :null}
               {(props.isContractResultExpanded && (data.contractNumber === props.contractNumber))? 
               ( <div className={styles.cardCointainer}>
              <div className={styles.conHeading}>{strings.OutageAlertsLabel}</div>
              <div>
                <EmergencyAlertContainer
                               accountData={accountDetails} dropDownData={props.dropDownData}
                               preferenceData={preferenceDetails[0].emrg} updateDropDownData={props.updateDropDownData}
                               selectedAccount={data} removePreference={props.removePreference}
                               formattedDataForEmrg={props.formattedDataForEmrg}
                               refreshPage={props.onContractResultClick}        
                               mainBpNumber={props.cpcData.bpNumber}
                               onlyOneBpEnrolled={props.onlyOneBpEnrolled}
                               isMultiAcc={props.isMultiAcc} staticContent={props.staticContent.ea}                              
                              />
                  </div>
               <div>
                <OutageAlertContainer
                               accountData={accountDetails} dropDownData={props.dropDownData}
                               preferenceData={preferenceDetails[0].outg} updateDropDownData={props.updateDropDownData}
                               selectedAccount={data} removePreference={props.removePreference}
                               formattedDataForOutg={props.formattedDataForOutg}
                               refreshPage={props.onContractResultClick}        
                               mainBpNumber={props.cpcData.bpNumber}
                               isMultiAcc={props.isMultiAcc} staticContent={props.staticContent.rm}                             
                              />
                </div>
                {(!props.isWebUser && data.contractStatus === app.appUtil.getAppConstants().MY_ACCOUNT_SERVICES.ACTIVE_ENROLLMENT_STATUS) ? <React.Fragment>
                <div className={styles.conHeading}>{strings.OtherAlertsLabel}</div>
                <div>
                <BudgetAssistantContainer
                               accountData={accountDetails} dropDownData={props.dropDownData}
                               preferenceData={preferenceDetails[0].buda} updateDropDownData={props.updateDropDownData}
                               selectedAccount={data} removePreference={props.removePreference}
                               formattedDataForBuda={props.formattedDataForBuda}
                               baEnrollmentDetailsVO={props.baEnrollmentDetailsVO}
                               refreshPage={props.onContractResultClick}
                               mainBpNumber={props.cpcData.bpNumber}
                               isMultiAcc={props.isMultiAcc} staticContent={props.staticContent.ba}
                               billingRateType={props.billingRateType}
                              />
                </div>
                <div>
                <CriticalPeakPricing
                               AlertName1={cppString.AlertName1}
                               AlertName2={cppString.AlertName2}
                               AlertExp={cppString.AlertExp}
                               accountData={accountDetails} dropDownData={props.dropDownData}
                               preferenceData={preferenceDetails[0].cpp} updateDropDownData={props.updateDropDownData}
                               cpcData={props.cpcData} removePreference={props.removePreference}
                               formattedDataForCpp={props.formattedDataForCpp}
                               isMultiAcc={props.isMultiAcc}
                               refreshPage={props.onContractResultClick}
                               expandedContract={data}
                               mainBpNumber={props.cpcData.bpNumber} staticContent={props.staticContent.cpp}
                              />
                </div></React.Fragment> : null}
                </div>) : null}
            </div>
          );
        })}
        <section>
                {props.viewShowMoreContracts?
                    <div className={styles.showMore}>
                        <button onClick={()=>props.handleShowMore(accountDetails.contractAccountNumber)}>Show More 
                            <i class="fa fa-angle-down" />
                        </button>
                    </div>
                : 
                    <div className={styles.showMore}>
                        { props.viewShowLessContracts ?                           
                            <button onClick={()=>props.handleShowLess(accountDetails.contractAccountNumber)}>
                                <label>
                                Show Less  <i class="fa fa-angle-up" />
                                </label>
                            </button>                            
                        : null}
                    </div>
                }
            </section>
      </div>
    </div>
  );
};

export default MultiAccountTray;
